import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { executeQueryJSON } from '@arcgis/core/rest/query';
import Query from '@arcgis/core/rest/support/Query';
import { MapService } from '@services/map.service';
import { PlanparcelDataService } from '@services/planparcel-data.service';

@Component({
    selector: 'app-sub-seq-search',
    templateUrl: './sub-seq-search.component.html',
    styleUrl: './sub-seq-search.component.scss'
})
export class SubSeqSearchComponent {
    baladeyaNameOptions: string[] = [];
    baladeyaGeometry = {};
    neighNameOptions: string[] = [];
    neighGeom = {};
    planNameOptions: string[] = [];
    planGeom = {};
    planFeature: any;

    planName: string = '';
    neighborhoodName: string = '';
    constructor(
        private http: HttpClient,
        private mapService: MapService,
        private planparcel: PlanparcelDataService
    ) { }

    ngOnInit() {
        this.queryBaladeyaNames();
    }

    queryBaladeyaNames() {
        //   debugger;
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE';
        const queryObject = new Query({
            where: '1=1',
            returnGeometry: true,
            outFields: ['BELEDIYE']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.baladeyaNameOptions = results.features.map(
                (feature) => feature.attributes.BELEDIYE
            );
            results.features.forEach((feature) => {
                this.baladeyaGeometry[feature.attributes.BELEDIYE] =
                    feature.geometry;
            });

            // console.log(this.baladeyaGeometry)
        });
    }

    queryNeighNames(baladeya: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/6/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=NEIGH_NAME';
        const queryObject = new Query({
            where: `BELEDIYE = N'${baladeya}'`, // Assuming BELEDIYE is the field name for baladeya
            returnGeometry: true,
            outFields: ['NEIGH_NAME']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.neighNameOptions = results.features.map(
                (feature) => feature.attributes.NEIGH_NAME
            );
            results.features.forEach((feature) => {
                this.neighGeom[feature.attributes.NEIGH_NAME] =
                    feature.geometry;
            });
        });
    }

    queryPlanNames(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONNAME_AR';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: true,
            outFields: ['SUBDIVISIONNAME_AR']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNameOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONNAME_AR
            );
            results.features.forEach((feature) => {
                this.planGeom[feature.attributes.SUBDIVISIONNAME_AR] =
                    feature.geometry;
            });
        });
    }

    //  queryPlanDetails(planNme: string) {
    //   const queryUrl = "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=parcel_plane,Parcel_AsBuilt,MadinahAerialPhotography_zone,Plan_Correct,Zoon_Code,Comparison,Balady_2,F3D";
    //   const queryObject = new Query({
    //      where: `SUBDIVISIONNAME_AR = N'${planNme}'`,
    //      returnGeometry: true,
    //      outFields: ['objectid', 'parcel_plane','Parcel_AsBuilt','MadinahAerialPhotography_zone','Plan_Correct','Zoon_Code',   'Comparison','Balady_2','F3D']
    //   });

    //   executeQueryJSON(queryUrl, queryObject).then((results) => {
    //      if (results.features.length > 0) {
    //        this.planFeature = results.features[0];
    //        this.objectid = this.planFeature.attributes.OBJECTID;
    //        this.parcelPlan = this.planFeature.attributes.parcel_plane;
    //        this.parcelAsbuilt = this.planFeature.attributes.Parcel_AsBuilt;
    //        this.MAPhotographyZone = this.planFeature.attributes.MadinahAerialPhotography_zone;
    //        this.planCorrect = this.planFeature.attributes.Plan_Correct;
    //        this.zoneCode = this.planFeature.attributes.Zoon_Code;
    //        this.comparison = this.planFeature.attributes.Comparison;
    //        this.balady2 = this.planFeature.attributes.Balady_2;
    //        this.F3D = this.planFeature.attributes.F3D;
    //       //  this.getPlanAttachments();
    //       //  console.log("fron func")
    //       //  console.log(feature.attributes)
    //      }

    //   });
    //  }

    liveSearchPlanNumber(planNumber: string) {
        if (planNumber.trim()) {
            const queryUrl =
                "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=SUBDIVISIONNUMBER='N'" +
                planNumber +
                "'&returnGeometry=true&outFields=SUBDIVISIONNAME_AR,NEIGHBORHOOD_NAME";
            this.http.get<any>(queryUrl).subscribe(
                (response: any) => {
                    // Check if response and response.features exist before accessing length
                    if (
                        response &&
                        response.features &&
                        response.features.length > 0
                    ) {
                        this.planName =
                            response.features[0].attributes.SUBDIVISIONNAME_AR;
                        this.neighborhoodName =
                            response.features[0].attributes.NEIGHBORHOOD_NAME;
                    } else {
                        // Handle case where no matching data was found
                        this.planName = ''; // Reset or handle as needed
                        this.neighborhoodName = ''; // Reset or handle as needed
                    }
                },
                (error) => {
                    // Handle error case
                    console.error('Error fetching plan details:', error);
                    this.planName = ''; // Reset or handle as needed
                    this.neighborhoodName = ''; // Reset or handle as needed
                }
            );
        }
    }

    onBaladeyaNameChange(event: any) {
        const selectedBaladeya = event.target.value;
        // console.log(this.baladeyaGeometry[selectedBaladeya]);
        this.mapService.mapView.goTo(
            this.baladeyaGeometry[selectedBaladeya].extent
        );
        // debugger;
        this.queryNeighNames(selectedBaladeya);
    }
    onNeighNameChange(event: any) {
        const selectedNeigh = event.target.value;
        this.mapService.mapView.goTo(this.neighGeom[selectedNeigh].extent);
        this.queryPlanNames(selectedNeigh);
    }
    onPlanNameChange(event: any) {
        const selectedPlan = event.target.value;
        this.mapService.mapView.goTo(this.planGeom[selectedPlan].extent);
        //  this.queryPlanDetails(selectedPlan);
    }
}
